import React from 'react';

import PropTypes from 'prop-types';
import { SocialIcons } from 'C4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ContentHeader = (props) => {
  const {
    header, subtitle, social, icon,
  } = props;

  return (
    <div className="contentHeader" id="contentHeader">
      <FontAwesomeIcon icon={['far', icon]} className="icon" />
      <h3>{header}</h3>
      <h6>{subtitle}</h6>
      {props.children}
      {social && <SocialIcons />}
      <hr />
    </div>
  );
};

export default ContentHeader;

ContentHeader.propTypes = {
  header: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node,
  social: PropTypes.bool,
};

ContentHeader.defaultProps = {
  header: 'CONTENT HEADER',
  subtitle: '',
  icon: '',
  children: null,
  social: false,
};
